import swal from "sweetalert";
export function formatError(errorResponse) {
    switch (errorResponse.message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';
            
        case errorResponse.message:
            swal("Oops", errorResponse.message, "error",{ button: "Try Again!",});
            break;

        default:
            return '';
    }
}

export function formatSuccess(componentName, successResponse) {
    switch (successResponse.message) {
        case successResponse.message:
            swal(componentName, successResponse.message, "success")
            break;

        default:
            return '';
    }
}